import {ChecklistRepositoryImpl} from '../repository/ChecklistRepositoryImpl';
import {ListChecklistsUseCase} from '../useCases/ListChecklistsUseCase';
import {GetChecklistByIdUseCase} from '../useCases/GetChecklistByIdUseCase';
import {CreateChecklistUseCase} from '../useCases/CreateChecklistUseCase';
import {UpdateChecklistUseCase} from '../useCases/UpdateChecklistUseCase';
import {SetChecklistStatusUseCase} from '../useCases/SetChecklistStatusUseCase';
import {DeleteChecklistUseCase} from '../useCases/DeleteChecklistUseCase';
import {ListVisitSubmissionsUseCase} from '../useCases/ListVisitSubmissionsUseCase';

// Factory class for Checklists feature
export class ChecklistsFactory {
  private static checklistsRepository: ChecklistRepositoryImpl | null = null;

  // Repository Singleton
  private static getChecklistsRepository (): ChecklistRepositoryImpl {
    if (!this.checklistsRepository) {
      this.checklistsRepository = new ChecklistRepositoryImpl();
    }
    return this.checklistsRepository;
  }

  // Use Cases Factory Methods
  static createListChecklistsUseCase (): ListChecklistsUseCase {
    return new ListChecklistsUseCase(this.getChecklistsRepository());
  }

  static createGetChecklistByIdUseCase (): GetChecklistByIdUseCase {
    return new GetChecklistByIdUseCase(this.getChecklistsRepository());
  }

  static createCreateChecklistUseCase (): CreateChecklistUseCase {
    return new CreateChecklistUseCase(this.getChecklistsRepository());
  }

  static createUpdateChecklistUseCase (): UpdateChecklistUseCase {
    return new UpdateChecklistUseCase(this.getChecklistsRepository());
  }

  static createSetChecklistStatusUseCase (): SetChecklistStatusUseCase {
    return new SetChecklistStatusUseCase(this.getChecklistsRepository());
  }

  static createDeleteChecklistUseCase (): DeleteChecklistUseCase {
    return new DeleteChecklistUseCase(this.getChecklistsRepository());
  }

  static createListVisitSubmissionsUseCase (): ListVisitSubmissionsUseCase {
    return new ListVisitSubmissionsUseCase(this.getChecklistsRepository());
  }

  // Reset factory (useful for testing)
  static reset (): void {
    this.checklistsRepository = null;
  }
}
